import { useCustomerLoginStore } from "../stores/login/customer";

export default defineNuxtRouteMiddleware(async (to, from) => {

const  { session, refresh} = await useSession()

const customer = useCustomerLoginStore()

if(!customer.loggedIn) return navigateTo('/login');

await refresh()

})
